import { createFileRoute } from '@tanstack/react-router'

import { AnnouncementBarPage } from '#/modules/content/announcement-bar-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/announcement-bar')({
  component: AnnouncementBarPage,
  validateSearch: validateListSearch,
})
